export function extractYoutubeVideoId(url) {

    if (!url) return "";

    url = url.trim();

    if (/^[a-zA-Z0-9_-]{11}$/.test(url)) {
        return url;
    }

    const patterns = [

        /[?&]v=([^&#]{11})/,

        /youtu\.be\/([^?&#]{11})/,

        /youtube\.com\/embed\/([^?&#]{11})/,

        /youtube\.com\/shorts\/([^?&#]{11})/,

        /youtube\.com\/live\/([^?&#]{11})/,

        /youtube\.com\/v\/([^?&#]{11})/

    ];

    for (const pattern of patterns) {

        const match = url.match(pattern);

        if (match) {
            return match[1];
        }

    }

    return "";
}

export function getYoutubeThumbnail(videoId) {

    if (!videoId) return "";

    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

}